import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getTrabajosGobierno = query =>
	fetch.get(
		`/trabajos-gobierno${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getTrabajoGobierno = ({ id, query }) =>
	fetch.get(
		`/trabajos-gobierno/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addTrabajoGobierno = data =>
	fetch.post('/trabajos-gobierno', data);
export const updateTrabajoGobierno = ({ id, ...data }) =>
	fetch.put(`/trabajos-gobierno/${id}`, data);
export const deleteTrabajoGobierno = id =>
	fetch.delete(`/trabajos-gobierno/${id}`);

// RTK Query
export const trabajosGobiernoApi = createApi({
	reducerPath: 'trabajosGobiernoApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getTrabajosGobierno: build.query({
			query: query => {
				return {
					url: `/trabajos-gobierno${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'TrabajosGobierno',
								id,
							})),
							{ type: 'TrabajosGobierno', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'TrabajosGobierno', id: 'LIST' }],
		}),
		getTrabajoGobierno: build.query({
			query: ({ id, query }) => {
				return {
					url: `/trabajos-gobierno/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [
				{ type: 'TrabajosGobierno', id },
			],
		}),
		addTrabajoGobierno: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-gobierno`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Trabajo Gobierno agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar trabajo gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'TrabajosGobierno', id: 'LIST' }],
		}),
		updateTrabajoGobierno: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-gobierno/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Trabajo Gobierno actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar trabajo gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'TrabajosGobierno', id },
			],
		}),
		deleteTrabajoGobierno: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-gobierno/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Trabajo Gobierno eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar trabajo gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'TrabajosGobierno', id },
			],
		}),
	}),
});

export const {
	useGetTrabajosGobiernoQuery,
	useGetTrabajoGobiernoQuery,
	useAddTrabajoGobiernoMutation,
	useUpdateTrabajoGobiernoMutation,
	useDeleteTrabajoGobiernoMutation,
} = trabajosGobiernoApi;
